<ng-container
    *ngIf="{
        lastSection: (lastSection$ | async),
        homePagesUrl: (homePagesUrl$ | async),
        isHomePage: (isHomePage$ | async)
    } as data"
>
    <div class="is-flex align-items-center h-100">
        <div class="tabs sm:hidden">
            <ul class="list-clear">
                <ng-container *ngIf="!isSearchPage">
                    <ng-container *ngTemplateOutlet="headerSections; context: { data }"> </ng-container>
                </ng-container>
                <ng-container *ngIf="isSearchPage">
                    <ng-container *ngTemplateOutlet="headerSectionsSearch"> </ng-container>
                </ng-container>
            </ul>
        </div>
    </div>
</ng-container>

<ng-template #headerSectionsSearch>
    <li [class.is-active]="isWomenSection">
        <a class="text-l topbar-link" (click)="changeSection('WOMEN')" role="button" tabindex="0" (keydown.enter)="changeSection('WOMEN')">
            {{ 'common.generic.sectionWomen' | translate }}
        </a>
    </li>
    <li [class.is-active]="isMenSection">
        <a class="text-l topbar-link" (click)="changeSection('MEN')" role="button" tabindex="0" (keydown.enter)="changeSection('MEN')">
            {{ 'common.generic.sectionMen' | translate }}
        </a>
    </li>
</ng-template>

<ng-template #headerSections let-data="data">
    <li *ngFor="let section of categories; let i = index" [class.is-active]="sections[i] === data.lastSection">
        <a class="text-l topbar-link" (click)="selectCategory($event, i)" [href]="data.homePagesUrl ? data.homePagesUrl[i] : section.locationPath">
            {{ section.name | translate }}
        </a>
    </li>
</ng-template>
